import {Component, EventEmitter, inject, Input, Output} from '@angular/core';
import {Game} from '../../../../../shared/model/game';
import {PermissionService} from '../../../../../core/services/permission.service';
import {SystemPower} from '../../../../../shared/model/permissions';
import {GenericCardComponent} from '../../../../../shared/components/generic-card/generic-card.component';
import {DecimalPipe} from '@angular/common';
import {TruncatePipe} from '../../../../../shared/pipes/truncate.pipe';


@Component({
  selector: 'app-game-card',
  standalone: true,
  imports: [
    GenericCardComponent,
    DecimalPipe,
    TruncatePipe
  ],
  templateUrl: './game-card.component.html',
  styleUrl: './game-card.component.css'
})
export class GameCardComponent {
  @Input() game!: Game;
  @Input() mine: boolean = false;
  @Output() editGame: EventEmitter<Game> = new EventEmitter<Game>();
  @Output() deleteGame: EventEmitter<Game> = new EventEmitter<Game>();

  private permissionService: PermissionService = inject(PermissionService);

  isCreator(game: Game): boolean {
    const user = this.permissionService.getCurrentUser();
    if (user) {
      return user.id === game.creatorId;
    }
    return false;
  }

  havingTables(game: Game) {
    return game.tablesAssociated > 0;
  }

  isAdministrator() {
    return this.permissionService.hasSystemPower(SystemPower.ADMINISTRATOR);
  }

  isTouchable(game: Game) {
    return this.isCreator(game) && !this.havingTables(game);
  }

  isLogged() {
    return this.permissionService.isLogged();
  }

}
